export default {
  versions: 'projects',
  errorMessage: 'Modification failed',
  versionmanage: 'Version Management',
  versionName: 'Version Name',
  creator: 'Creator',
  hideVersion: 'Hide version',
  title: 'Version List',
  infoTitle: 'Version Info',
  versionEdit: 'Edit Version',
  deleteSuccessText: 'Delete Successfully',
  searchHeadText: 'Search',
  createButton: 'Create Project',
  createDCOButton: 'Create New DCO Version',
  createMultiButton: 'Create Variation Project',
  deleteButton: 'Delete',
  downloadButton: 'Bulk download',
  channelName: 'Network:',
  platforms: 'Platforms:',
  packageName: 'Package Name',
  productName: 'Product Name：',
  deleteConfirmButton: 'Delete',
  deleteConfirmText: 'Are you sure you want to delete the current project？',
  deleteTitle: 'Are you sure you want to delete this',
  deleteTips:
    "This project will be deleted immediately,You can't undo this action.",
  viewAllProduct: 'View All Product',
  language: 'Language:',
  actionButton: {
    edit: 'Edit',
    copy: 'Copy',
    download: 'Download',
    preview: 'Preview',
    hide: 'Hide',
    renew: 'Undo',
    viewData: 'View Data',
    dcoConfiguration: 'DCO Configuration',
    push: 'Apply',
    pushLog: 'Push Record',
    pushdownloadLog: 'Export & Download History',
    copyToMulti: 'Copy to Variant Feature Changer',
    copyToPs: 'Copy to Content Editor',
    copyToDco: 'Copy to DCO',
    copyAllResource: 'Download All Assets',
  },
  table: {
    column: {
      action: 'Operations',
      id: 'Serial Number',
      versionCount: 'Ver. Count',
      description: 'Version Name',
      lang: 'Language',
      createdTime: 'Creation Time',
      hide: 'Hide version',
      unPublished: 'Unpublished',
    },
  },
  createBy: {
    mw: 'MW',
    mindworks: 'Mindworks',
    self: 'Me',
    placeholder: 'Select creator',
  },
  channelSetting: {
    contentRating: 'Age Select',
    noContentRating: 'None',
    contentRating8: 'Age 8+',
    contentRating12: 'Age 12+',
    contentRating16: 'Age 16+',
  },
  materialInteractive: {
    singStep: 'One step',
    moreStep: 'Two or More Steps',
    realStep: {
      tips: 'The setting of trial play steps affects the material delivery effect, please choose accurately.',
    },
    modify: {
      tips: 'Modifying the game steps and then re-downloading/pushing will incur a re-charge.',
    },
    gameStep: 'Playable ad steps',
    gameJourney: 'The number of game steps in the complete trial process',
    gameJourneyTips:
      'Number of interactions from the game start to redirecting to the app store',
    download: 'Download',
  },
}
